/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ProgramActionLinkMngDto { 
    /**
     * The target URL that is to be opened when link is clicked.
     */
    url: string;
    /**
     * The link target. It describes how the link should be opened (the same tab, new tab...)
     */
    target: ProgramActionLinkMngDto.TargetEnum;
}
export namespace ProgramActionLinkMngDto {
    export type TargetEnum = 'self' | 'blank';
    export const TargetEnum = {
        Self: 'self' as TargetEnum,
        Blank: 'blank' as TargetEnum
    };
}


